module.exports = __webpack_public_path__ + "static/media/2.5a99a596.webp";